import axios from "axios";
import { createClient } from "../util/axios-helpers";
import { endpoint } from "../util/http-helpers";

export interface OpenDoorResponse {
    success: boolean;
    message: string;
}

export const openDoor = () => {
    const client = createClient(axios);
    return client.post<OpenDoorResponse>(endpoint('api/v1/unit/open-door'));
};
